import { Typography } from '@material-ui/core'
import React from 'react'

import { getTranslate } from '../../../../localization'
import useStyles from './styles/index.styles'

type Props = { title: string }

const SimpleFacility = ({ title }: Props) => {
  const classes = useStyles()
  return (
    <div className={classes.root}>
      <div className={classes.main}>
        <div className={classes.circle} />
        <Typography variant="h6" className={classes.title}>
          {getTranslate(title)}
        </Typography>
      </div>
    </div>
  )
}

export default SimpleFacility
